import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { focusOutline } from '@hivebrite/design-system/Theme';

import IconExternalLink from 'hb-react/shared/icons/ExternalLink';

const NoPreviewExternalLink = ({ url }) => (
  <StyledWrapper>
    <StyledText>
      {s__('Portfolio|There is no available preview for this external link')}
    </StyledText>
    <StyledText mb={8}>
      {s__('Portfolio|Please click below to view it')}
    </StyledText>
    <StyledAction href={url} data-testid="anchor-action" target="_blank">
      <IconExternalLink height={80} width={80} />
    </StyledAction>
  </StyledWrapper>
);

NoPreviewExternalLink.propTypes = {
  url: PropTypes.string.isRequired,
};

export default NoPreviewExternalLink;

const StyledWrapper = styled(Box).attrs({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  height: 'inherit',
  alignItems: 'center',
})``;

const StyledAction = styled.a`
  ${focusOutline};
  color: ${(props) => props.theme.colors.primary};

  cursor: pointer;
  user-select: none;
  z-index: 1;

  &:hover,
  &:focus {
    color: ${(props) => props.theme.colors.primaryDark};
  }
`;

const StyledText = styled(Box).attrs({
  display: 'block',
  font: 'body-asphalt-italic',
})``;
